<script setup>
defineProps({
  conversationsCount: {
    type: [Number, String],
    default: 0,
  },
  avgFirstResponseTime: {
    type: String,
    default: '--',
  },
  avgResolutionTime: {
    type: String,
    default: '--',
  },
});
</script>

<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
    <div
      class="flex flex-col gap-2 p-4 rounded-xl outline outline-1 outline-n-container bg-n-solid-2"
    >
      <span class="text-sm text-n-slate-11">
        {{ $t('CUSTOM_SLA_REPORTS.TABLE_HEADER.CONVERSATIONS') }}
      </span>
      <span class="text-heading-1 text-n-slate-12">{{
        conversationsCount
      }}</span>
    </div>
    <div
      class="flex flex-col gap-2 p-4 rounded-xl outline outline-1 outline-n-container bg-n-solid-2"
    >
      <span class="text-sm text-n-slate-11">
        {{ $t('CUSTOM_SLA_REPORTS.TABLE_HEADER.AVG_FIRST_RESPONSE_TIME') }}
      </span>
      <span class="text-heading-1 text-n-slate-12">{{
        avgFirstResponseTime
      }}</span>
    </div>
    <div
      class="flex flex-col gap-2 p-4 rounded-xl outline outline-1 outline-n-container bg-n-solid-2"
    >
      <span class="text-sm text-n-slate-11">
        {{ $t('CUSTOM_SLA_REPORTS.TABLE_HEADER.AVG_RESOLUTION_TIME') }}
      </span>
      <span class="text-heading-1 text-n-slate-12">{{
        avgResolutionTime
      }}</span>
    </div>
  </div>
</template>
